import {
  EMAIL_NOTIFICATION_FETCH_SUCCESS,
  DOWNLOAD_EMAIL_NOTIFICATION_SUCCESS
} from '../constant/actionType';

const initialState = {
  csv: null,
  emailNotifications: [],
  isLoaded: false
};

const emailNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_NOTIFICATION_FETCH_SUCCESS:
      return {
        ...state,
        emailNotifications: action.data,
        isLoaded: true
      };

    case DOWNLOAD_EMAIL_NOTIFICATION_SUCCESS:
      return {
        ...state,
        csv: action.data
      };

    default:
      return state;
  }
};

export default emailNotificationReducer;
